var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8789062,39.4648438l-10-10C33.9345703,28.5205078,32.6787109,28,31.3427734,28h-0.8726807 C32.6733398,25.2579956,34,21.782959,34,18c0-8.8222656-7.1777344-16-16-16S2,9.1777344,2,18s7.1777344,16,16,16 c3.782959,0,7.2579956-1.3266602,10-3.5299072v0.8726807c0,1.3359375,0.5205078,2.5917969,1.4648438,3.5361328l10,10 C40.1874924,45.6015625,41.1494141,46,42.171875,46C44.2822266,46,46,44.2822266,46,42.171875 C46,41.1494141,45.6015625,40.1875,44.8789062,39.4648438z M18,32c-7.7197266,0-14-6.2802734-14-14S10.2802734,4,18,4 s14,6.2802734,14,14S25.7197266,32,18,32z M42.171875,44c-0.4814453,0-0.953125-0.1953125-1.2929688-0.5351562l-10-10 C30.3124943,32.8984375,30,32.1445312,30,31.3427734V30h1.3427734c0.8017578,0,1.5556641,0.3125,2.1220703,0.8789062l10,10 C43.8046875,41.21875,44,41.6904297,44,42.171875C44,43.1796875,43.1796875,44,42.171875,44z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMedium);
export default __webpack_public_path__ + "static/media/search--medium.cdfeb1946dff4644dac10c304d60d756.svg";
export { ForwardRef as ReactComponent };